module.exports = __webpack_public_path__ + "files/bfa44aee786083880e88d932017d30fe.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/foods.png
// module id = 586
// module chunks = 59